/**
 * @fileoverview POST handler for the "/generative_ai/agent" endpoint
 */
import fetch from "@lib/fetch";

import { buildJsonPayloadFetchRequestArgs } from "../formData";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentCacheKeys } from "./constants";
import type { PostGenerativeAiAgentProps, GenerativeAiAgentResult } from "./types";

export const postGenerativeAiAgent = reactQueryMutationAdapter(
  generativeAiAgentCacheKeys,
  ({ files, ...payload }: PostGenerativeAiAgentProps): Promise<GenerativeAiAgentResult> => {
    // A save carrying new context files goes multipart: the payload ships as ONE agent_json part
    // (bracket-flattening the nested agent payload is lossy) next to raw files[] parts. File-less
    // saves stay plain JSON.
    const { params, options, setContentType } = buildJsonPayloadFetchRequestArgs(
      payload,
      files,
      "agent_json",
      "files"
    );

    return fetch("/generative_ai/agent", "POST", params, options, {
      setContentType,
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
